export const applySlotsToQuadrants = (quadrants, slotIds, editOnce = true) => {
  const childrenToEnable = new Set();

  // mark in‑use
  quadrants.forEach((q) => {
    if (slotIds.has(q.id)) {
      q.inUse = true;
      q.disabled = editOnce;
      (q.children || []).forEach((c) => childrenToEnable.add(c));
    }
  });

  // re‑enable their children
  quadrants.forEach((q) => {
    if (childrenToEnable.has(q.id) && !q.inUse) {
      q.disabled = false;
    }
  });

  return quadrants;
};

const parsePercentCoord = (coordStr) => {
  return parseFloat(coordStr.replace("%", ""));
};

const toPoint = (q) => {
  // origin at (50,50), invert X-axis
  const x = (50 - parsePercentCoord(q.left)) * -1;
  const y = 50 - parsePercentCoord(q.top);
  return [x, y];
};

const getRotationDirection = ([x1, y1], [x2, y2]) => {
  const cross = x1 * y2 - y1 * x2;
  return cross > 0 ? "counter-clockwise" : cross < 0 ? "clockwise" : null;
};

export const applyRotationAndTerminus = (tree, assignedQuads) => {
  const pts = assignedQuads.map(toPoint).filter(([x, y]) => x || y);
  if (pts.length > 1) {
    for (let i = 1; i < pts.length; i++) {
      const d = getRotationDirection(pts[0], pts[i]);
      if (d) {
        tree.direction = d;
        break;
      }
    }
  }
  if (pts.length > 2) {
    const [sumX, sumY] = pts.reduce(
      ([sx, sy], [x, y]) => [sx + x, sy + y],
      [0, 0],
    );
    if (sumX === 0 && sumY === 0) {
      tree.terminusActive = true;
    }
  }
  return tree;
};
